import { render, staticRenderFns } from "./CompanyView.vue?vue&type=template&id=59d9862e"
import script from "./CompanyView.vue?vue&type=script&lang=js"
export * from "./CompanyView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports